// extracted by mini-css-extract-plugin
export default {"dialogFooterBottomRow":"SzXSXA_aogFSYw3X9PvP","dialogFooterBottomCorner":"vCjvWOHPY0YdtKKQ44_v"};